module.exports = __webpack_public_path__ + "static/media/Ellipse_3.f6ba88ba.png";